import { Box, SxProps } from "@mui/material";
import { PropsWithChildren } from "react";

export const TagChip = ({
  children,
  className,
  sx,
}: PropsWithChildren<{ className?: string; sx?: SxProps }>) => {
  return (
    <Box
      sx={{
        backgroundColor: "#FAE9F0",
        px: 1,
        borderRadius: 10,
        ...sx,
      }}
      alignContent={"center"}
      className={className}
    >
      <span className="text-pink">{children}</span>
    </Box>
  );
};
